import {
  UserRoleDicionary,
  UserRoleEnum,
} from '@/app/services/usersService/user'
import { Button } from '../../../../../components/ui/button'
import {
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogTrigger,
} from '@/view/components/ui/dialog'
import { useRemoveExecutivesController } from './useRemoveExecutiveController'

interface RemoveExecutiveProps {
  role: UserRoleEnum.MANAGER | UserRoleEnum.SUPERVISOR | UserRoleEnum.LEADER
  executive: string
  team: string
}
export const RemoveExecutive = ({
  role,
  executive,
  team,
}: RemoveExecutiveProps) => {
  const { handleRemove, isPending } = useRemoveExecutivesController()

  return (
    <DialogContent className="p-5">
      <DialogClose />
      <div className="-mt-4">
        <p className="mr-5">
          {'Deseja realmente remover o '}
          <span className="font-bold">
            {UserRoleDicionary[role]} {executive}
          </span>
          {' da equipe '}
          <span className="font-bold">{team}</span>?
        </p>
      </div>
      <DialogFooter className="flex items-center">
        <DialogClose className="p-2">Cancelar</DialogClose>
        <DialogTrigger asChild>
          <Button
            onClick={() => handleRemove(role)}
            disabled={isPending}
            className="bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
          >
            Remover
          </Button>
        </DialogTrigger>
      </DialogFooter>
    </DialogContent>
  )
}
